interface Props {
  nickname: string;
  dayPillar?: string;
  date?: string;
}

function getGreeting() {
  const h = new Date().getHours();
  if (h >= 6 && h < 12) return { text: "좋은 아침이에요", emoji: "☀️" };
  if (h >= 12 && h < 18) return { text: "안녕하세요", emoji: "🌤" };
  if (h >= 18 && h < 22) return { text: "좋은 저녁이에요", emoji: "🌙" };
  return { text: "늦은 밤이네요", emoji: "🌑" };
}

export default function DailyBanner({ nickname, dayPillar, date }: Props) {
  const greeting = getGreeting();
  const today = new Date();
  const dateStr =
    date ??
    today.toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
    });

  return (
    <div
      className="rounded-2xl px-6 py-5 text-[var(--color-text-primary)]"
      style={{ background: "linear-gradient(90deg, #2D1F83 0%, #8F5FB2 100%)" }}
    >
      <div className="flex items-start justify-between flex-wrap gap-2">
        <div>
          <p className="text-[var(--color-accent)] text-sm font-medium mb-1">
            {greeting.text} {greeting.emoji}
          </p>
          <h2
            className="text-xl font-bold"
            style={{ fontFamily: "var(--font-brand)" }}
          >
            {nickname}님
          </h2>
          <p className="text-[var(--color-text-secondary)] text-sm mt-1">
            {dateStr}
            {dayPillar && (
              <span className="ml-2 bg-white/10 rounded-md px-2 py-0.5 text-[var(--color-accent)] font-semibold">
                {dayPillar}일
              </span>
            )}
          </p>
        </div>
        <div className="text-right">
          <p className="text-[var(--color-secondary)] text-xs">오늘의 일진</p>
          {dayPillar ? (
            <p className="text-3xl font-bold text-[var(--color-accent)] mt-0.5">
              {dayPillar}
            </p>
          ) : (
            <p className="text-[var(--color-text-tertiary)] text-sm mt-1">
              불러오는 중...
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
